import { TextField } from '@mui/material'
import { useFieldContext } from '@zealth/core/form/contexts'
import type { TextFormFieldProps } from '@zealth/core/formFields/types'

export const TextFormField = ({
  label,
  placeholder,
  optional,
}: TextFormFieldProps) => {
  const field = useFieldContext<string>()

  return (
    <TextField
      fullWidth
      required={!optional}
      label={label}
      placeholder={placeholder}
      value={field.state.value ?? ''}
      error={field.state.meta.errors.length > 0}
      helperText={field.state.meta.errors[0]?.message ?? ' '}
      onBlur={field.handleBlur}
      onChange={e => field.handleChange(e.target.value)}
    />
  )
}
